import React from "react";
import { useParams } from "react-router-dom";
import blog1 from "../../images/blog/1.jpg";
import blog2 from "../../images/blog/2.jpg";
import "./style.css";

const blogPosts = {
  1: {
    title:
      "How will the Vacant Unit Tax affect real estate transactions and realtors in the upcoming years?",
    image: blog1,
    author: "Babette Turner",
    date: "Jan 5, 2023",
    content: `
      <p>
        Ottawa has introduced a <span class="highlight-text">Vacant Unit Tax (VUT)</span>,  and there are implications that vendors, purchasers, and real estate agents should be aware of. It is important for real estate agents to take the <span class="highlight-text">VUT</span> into consideration when drafting agreements. Failure to do so could result in liability against agents.
      </p>
      <p>
        Buyers may or may not be aware of the new Ottawa <span class="highlight-text">VUT</span>. Buyers that are currently homeowners in the Ottawa area would have received notifications from the city regarding the upcoming VUT, and the requirement to submit a declaration. However, first-time home buyers or buyers relocating from other areas would not be aware of such a requirement. Either way, buyers expect their agents to protect their interests and ensure that the Agreement of Purchase and Sale (APS) is drafted in such a manner – and the VUT will certainly impact the drafting of the APS.
      </p>
      <p>
        The City of Ottawa provides the following information on the <span class="highlight-text">VUT</span> concerning the purchase and sale of properties:
      </p>
      <ul class="bullet-list">
        <li>
          For transactions between January 1st and the closing of the <span class="highlight-text">VUT</span> declaration period on April 30th, vendors must complete the VUT property occupancy declaration in accordance with the VUT by-law. As the <span class="highlight-text">VUT</span> declaration is for the prior reference year, only vendors will know their property's occupancy status in the previous year.
        </li>
        <li>
          For transactions between May 1st and December 31st, buyers must submit a VUT declaration the following year. They will be able to claim the exemption for properties which are sold in the reference year.
        </li>
      </ul>
      <p>
        The <span class="highlight-text">VUT</span> is a tax at the rate of 1% of the MPAC assessment value of the property. Consider a property with an assessment value of $600,000. If the property was vacant for at least 184 days in 2022 (and does not meet criteria for any of the exemptions), and the Vendor does not submit a <span class="highlight-text">VUT</span> declaration, an additional $6,000 would be added to the final 2023 tax bill.
      </p>
      <p>
        Not all properties are subject to the VUT. Commercial, industrial, and multi-residential properties are exempt from the VUT. It’s important to note that for all residential tax class properties where a <span class="highlight-text">VUT</span> declaration has not been completed, the property will be DEEMED to have been unoccupied and will therefore be subject to the <span class="highlight-text">VUT</span>. In addition, the <span class="highlight-text">VUT</span> will form a lien on the property, and unpaid taxes will become the responsibility of the buyers.
      </p>
      <p>
        The <span class="highlight-text">VUT</span> is a new source of potential liability for real estate agents. When drafting their APS’s, agents should ensure that the VUT declaration has been taken into account. Unfortunately, the January 1st, 2023 OREA Standard Clauses does not have a standard clause for VUT, and as such, it may get overlooked when determining which clauses to include in the APS.
      </p>
      <p>
        Finally, how should real estate agents address the <span class="highlight-text">VUT</span>? When listing a property on the MLS system, they may wish to indicate the vacancy status. For transactions that will be closing between January 1st and April 30th of any year, they will want to ensure their APS Schedule As include clauses where the vendors represent and warrant the vacancy status of the property and agree to provide the buyers with a copy of the VUT declaration prior to closing.
      </p>
    `,
  },
  2: {
    title: "Second Blog Coming!!",
    image: blog2,
    author: "By Author Name",
    date: "Dec 17, 2022",
    content: `
      <p>
        When you're writing your next post, consider this: 80% of people will read your blog headline, but only 20% will stay for the rest.
      </p>
      <p>
        So, if headlines are 400% more important than what comes after them (where there’s already ever-increasing competition to attract eyes), you need to be more concise than ever to get attention.
      </p>
      <p className="important-paragraph">
        The Importance of Title Length
      </p>
      <p>
        A guide on the right length for your post titles
      </p>
      <p>
        If you want to keep your followers’ attention while conveying your brilliant wordplay, keep headline character counts as close as possible to 58 characters (including spaces).
      </p>
      <p>
        Wait, did you even read this? Congrats, you’re among the 20%.
      </p>
      <p>
        Read more at: <a href="www.how.to.blog">www.how.to.blog</a>
      </p>
      <p>
        Maintaining a blog is a great way to have original content on your website and increasing your site's visibility and rank on search engines.
      </p>
    `,
  },
};

const BlogPostMainComponent = () => {
  const { id } = useParams();

  const blogPost = blogPosts[id];

  if (!blogPost) {
    return <div>Blog post not found.</div>;
  }

  return (
    <div className="blog-post-container">
      <h1 className="blog-post-title">{blogPost.title}</h1>
      <p className="blog-post-author">Author: {blogPost.author}</p>{" "}
      <p className="blog-post-date">Date: {blogPost.date}</p>{" "}
      <img src={blogPost.image} className="blog-post-image" />
      <div
        className="blog-post-content"
        dangerouslySetInnerHTML={{ __html: blogPost.content }}
      />
    </div>
  );
};

export default BlogPostMainComponent;
